import { render, staticRenderFns } from "./centerData.vue?vue&type=template&id=0fd3d767"
import script from "./centerData.vue?vue&type=script&lang=js"
export * from "./centerData.vue?vue&type=script&lang=js"
import style0 from "./centerData.vue?vue&type=style&index=0&id=0fd3d767&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports